import { Conversations } from "@/components/conversations";
import { Matches } from "@/components/matches";
import { SearchBar } from "@/components/search-bar";
import { BACKEND_URL } from "@/config";
import { useToken } from "@/global_state";
import { EmptyConversation, StartedConversation } from "@/types";
import axios from "axios";
import { use } from "i18next";
import { useEffect, useState } from "react";

export default function MatchesPage() {
  const [emptyConversations, setEmptyConversations] = useState<
    EmptyConversation[] | null
  >(null);
  const [startedConversations, setStartedConversations] = useState<
    StartedConversation[] | null
  >(null);
  const [authToken, setAuthToken] = useToken();

  const fetchEmptyConversations = async () => {
    const response = await axios.get(`${BACKEND_URL}/api/conversations/empty/`);
    setEmptyConversations(response.data.results);
  };

  const fetchStartedConversations = async () => {
    const response = await axios.get(
      `${BACKEND_URL}/api/conversations/started/`
    );
    setStartedConversations(response.data.results);
  };

  useEffect(() => {
    if (authToken) {
      fetchEmptyConversations();
      fetchStartedConversations();
    }
  }, [authToken]);

  return (
    <div className="min-h-screen bg-gray-900 text-gray-100">
      <div className="container mx-auto p-4">
        <SearchBar />
        <div className="mt-6">
          <Matches conversations={emptyConversations} />
        </div>
        <div className="mt-6">
          <Conversations conversations={startedConversations} />
        </div>
      </div>
    </div>
  );
}
